import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

interface EmailStylesProps {
  backgroundImage?: string;
  isFocused?: boolean;
}

export const EmailStyles = styled(OnboardingPage)<EmailStylesProps>`
  --background: ${(props) =>
    props.backgroundImage
      ? `linear-gradient(180deg, rgba(10, 2, 26, 0.8) 19.99%, rgba(10, 2, 26, 0.3) 46.81%, #0A021A 84.92%), url('${props.backgroundImage}') center/cover no-repeat`
      : 'linear-gradient(180deg, rgba(10, 2, 26, 0.8) 19.99%, rgba(10, 2, 26, 0.3) 46.81%, #0A021A 84.92%)'};

  ion-content {
    .email-content-wrapper {
      position: absolute;
      bottom: 40px;
      left: 0;
      right: 0;
      width: 100%;

      @media (max-width: 768px) {
        bottom: ${(props) => (props.isFocused ? '40%' : '40px')};
        transition: bottom 0.3s ease;
      }
    }
    .onboarding-email-title {
      margin: 0 0 8px;
      text-align: center;
    }

    .images-container {
      margin: 16px 0;
      height: 268px;
      width: 100%;
      background-color: transparent;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
      }
    }

    .email-title {
      @media screen and (max-width: 360px) {
        margin-bottom: 10px;
      }
    }

    .email-disclaimer {
      text-align: center;
      margin: 12px 0 0;
    }

    .email-input-container {
      max-width: 372px;
      padding: 0 16px;
      width: 100%;
      margin: 16px auto 0;
    }

    .email-protection {
      margin: 16px auto;
      padding: 0 16px;
      max-width: 372px;
    }
  }
`;
